/* eslint-disable max-len, i18next/no-literal-string */
import React from 'react';

export function Megaphone(): JSX.Element {
  return (
    <svg width='36' height='37' viewBox='0 0 36 37' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.92443 10.5H15.3138C15.7585 10.5 16.1906 10.3518 16.5417 10.0787L26.3341 2.4624C27.6365 1.44935 29.5363 2.36046 29.5617 4.01034L29.9336 28.1838C29.9598 29.8871 27.9807 30.8413 26.6644 29.76L16.5534 21.4545C16.1956 21.1607 15.7469 21 15.2839 21H5.5C4 20.8333 1 19.7 1 16.5C1 13.5523 3.54553 11.5097 5.11938 10.6849C5.36724 10.555 5.64459 10.5 5.92443 10.5Z'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <ellipse cx='29' cy='16' rx='5.5' ry='15' fill='#F1F3F5' stroke='#153F66' strokeWidth='2' strokeLinecap='round' />
      <path
        d='M12.291 21H4.5L8.22788 23.8995C8.71505 24.2784 9 24.861 9 25.4782V30.1716C9 30.702 9.21071 31.2107 9.58579 31.5858L12.5858 34.5858C13.3668 35.3668 14.6332 35.3668 15.4142 34.5858L16.0858 33.9142C16.8668 33.1332 16.8668 31.8668 16.0858 31.0858L15.9599 30.9599C15.661 30.661 15.4645 30.2751 15.3986 29.8576L14.2665 22.6881C14.113 21.716 13.2752 21 12.291 21Z'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M28.5 13C29.1667 13.1667 30.5 14.1 30.5 16.5C30.5 18.9 29.1667 19.8333 28.5 20'
        stroke='#FF3E51'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
}
